function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
export var createGpuBufferFromMat4 = function(device, mat4, usage) {
    mat4 = new Float32Array(mat4);
    var gpuBuffer = device.createBuffer({
        size: mat4.byteLength,
        usage: usage,
        mappedAtCreation: true
    });
    var writeArray = new Float32Array(gpuBuffer.getMappedRange());
    writeArray.set(mat4);
    gpuBuffer.unmap();
    return gpuBuffer;
};
export var createGpuBufferFromFloat = function(device, float, usage) {
    var gpuBuffer = device.createBuffer({
        size: 4,
        usage: usage,
        mappedAtCreation: true
    });
    var writeArray = new Float32Array(gpuBuffer.getMappedRange());
    writeArray[0] = float;
    gpuBuffer.unmap();
    return gpuBuffer;
};
export var createGpuBufferFromVec2 = function(device, vec2, usage) {
    var gpuBuffer = device.createBuffer({
        size: 8,
        usage: usage,
        mappedAtCreation: true
    });
    var writeArray = new Float32Array(gpuBuffer.getMappedRange());
    writeArray.set(vec2);
    gpuBuffer.unmap();
    return gpuBuffer;
};
var _total = /*#__PURE__*/ new WeakMap(), _samples = /*#__PURE__*/ new WeakMap(), _cursor = /*#__PURE__*/ new WeakMap(), _numSamples = /*#__PURE__*/ new WeakMap();
// Note: We disallow negative values as this is used for timestamp queries
// where it's possible for a query to return a beginning time greater than the
// end time. See: https://gpuweb.github.io/gpuweb/#timestamp
export var NonNegativeRollingAverage = /*#__PURE__*/ function() {
    "use strict";
    function NonNegativeRollingAverage() {
        var numSamples = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 30;
        _class_call_check(this, NonNegativeRollingAverage);
        _class_private_field_init(this, _total, {
            writable: true,
            value: 0
        });
        _class_private_field_init(this, _samples, {
            writable: true,
            value: []
        });
        _class_private_field_init(this, _cursor, {
            writable: true,
            value: 0
        });
        _class_private_field_init(this, _numSamples, {
            writable: true,
            value: void 0
        });
        _class_private_field_set(this, _numSamples, numSamples);
    }
    _create_class(NonNegativeRollingAverage, [
        {
            key: "addSample",
            value: function addSample(v) {
                if (!Number.isNaN(v) && Number.isFinite(v) && v >= 0) {
                    _class_private_field_set(this, _total, _class_private_field_get(this, _total) + (v - (_class_private_field_get(this, _samples)[_class_private_field_get(this, _cursor)] || 0)));
                    _class_private_field_get(this, _samples)[_class_private_field_get(this, _cursor)] = v;
                    _class_private_field_set(this, _cursor, (_class_private_field_get(this, _cursor) + 1) % _class_private_field_get(this, _numSamples));
                }
            }
        },
        {
            key: "get",
            value: function get() {
                return _class_private_field_get(this, _total) / _class_private_field_get(this, _samples).length;
            }
        }
    ]);
    return NonNegativeRollingAverage;
}();
